import React from 'react';

type P = { size?: number };
const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
});

export const IconScissors = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <circle cx="6" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <line x1="20" y1="4" x2="8.12" y2="15.88" />
    <line x1="14.47" y1="14.48" x2="20" y2="20" />
    <line x1="8.12" y1="8.12" x2="12" y2="12" />
  </svg>
);
export const IconLeft = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
export const IconRight = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
export const IconCalendar = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
export const IconShare = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);
export const IconUpload = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);
export const IconPlus = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
export const IconMinus = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
export const IconClose = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
export const IconCheck = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
export const IconGrid = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);
export const IconVolume = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
  </svg>
);
export const IconVolumeOff = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <line x1="23" y1="9" x2="17" y2="15" />
    <line x1="17" y1="9" x2="23" y2="15" />
  </svg>
);
export const IconDownload = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
export const IconCopy = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);
export const IconTrash = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);
export const IconUser = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
export const IconLogout = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);
export const IconImage = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);
export const IconKey = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <circle cx="7.5" cy="15.5" r="4.5" />
    <path d="M10.7 12.3 21 2M16 7l3 3" />
  </svg>
);

export const IconMegaphone = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z" />
    <path d="M15 9a4 4 0 0 1 0 6" />
    <path d="M18 6.5a8 8 0 0 1 0 11" />
  </svg>
);

/** A framed banner with a picture and text lines: an advertisement. */
export const IconAdvert = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 9h18" />
    <path d="M6.5 16.5l2.5-3 2 2.2 1.5-1.5 2 2.3" />
    <path d="M14.5 6.5h4" />
  </svg>
);

export const IconBolt = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
  </svg>
);

export const IconFirst = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polyline points="11 17 6 12 11 7" />
    <polyline points="18 17 13 12 18 7" />
    <line x1="4" y1="6" x2="4" y2="18" />
  </svg>
);
export const IconLast = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <polyline points="13 17 18 12 13 7" />
    <polyline points="6 17 11 12 6 7" />
    <line x1="20" y1="6" x2="20" y2="18" />
  </svg>
);
export const IconUsers = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
    <path d="M16 4.5a3.5 3.5 0 0 1 0 7" />
    <path d="M18 14a6.5 6.5 0 0 1 3.5 6" />
  </svg>
);
export const IconBook = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z" />
    <path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z" />
  </svg>
);

export const IconEye = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <path d="M1.5 12S5.5 5 12 5s10.5 7 10.5 7-4 7-10.5 7S1.5 12 1.5 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
export const IconPeople = ({ size = 20 }: P) => (
  <svg {...base(size)}>
    <circle cx="12" cy="7" r="3.2" />
    <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
    <circle cx="4.5" cy="10" r="2.2" />
    <circle cx="19.5" cy="10" r="2.2" />
    <path d="M1 18a3.6 3.6 0 0 1 3.5-3.4M23 18a3.6 3.6 0 0 0-3.5-3.4" />
  </svg>
);
